import React from 'react'
import { Link } from 'react-router-dom'
import { BookOpen, LayoutDashboard, Briefcase, Users, FileText, Wrench } from 'lucide-react'

export default function HelpPage() {
  return (
    <div data-testid="help-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Getting Started</h1>
          <p className="page-subtitle">Quick practical guide for daily CRM operations</p>
        </div>
      </div>

      <div style={{ display: 'grid', gap: 'var(--sp-4)' }}>
        <section className="card" data-testid="help-section-purpose">
          <div className="card-header">
            <div className="flex items-center gap-2"><BookOpen size={16} /><h3 style={{ fontWeight: 600 }}>What this CRM is for</h3></div>
          </div>
          <div className="card-body" style={{ color: 'var(--color-text-secondary)' }}>
            This CRM helps your team run the full tent rental lifecycle: manage clients, create quotes, convert booked work to jobs,
            assign crew, and move jobs through completion.
          </div>
        </section>

        <section className="card" data-testid="help-section-core-workflow">
          <div className="card-header"><h3 style={{ fontWeight: 600 }}>Core workflow</h3></div>
          <div className="card-body" style={{ display: 'grid', gap: 8 }}>
            <div>1. Create a client</div>
            <div>2. Create a quote</div>
            <div>3. Convert quote to job</div>
            <div>4. Assign crew</div>
            <div>5. Update job status to completion</div>
          </div>
        </section>

        <section className="card" data-testid="help-section-daily-workflow">
          <div className="card-header"><h3 style={{ fontWeight: 600 }}>Daily workflow / where to start</h3></div>
          <div className="card-body" style={{ display: 'grid', gap: 8 }}>
            <div>• Start on Dashboard to review metrics, attention queue, and today’s work.</div>
            <div>• Use Schedule (Jobs) to manage upcoming work, crew readiness, and quick status updates.</div>
            <div>• Use Client Workspace for client-specific quotes, jobs, and key activity.</div>
          </div>
        </section>

        <section className="card" data-testid="help-section-key-screens">
          <div className="card-header"><h3 style={{ fontWeight: 600 }}>Key screens</h3></div>
          <div className="card-body" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 8 }}>
            <Link to="/dashboard" className="btn btn-ghost btn-sm"><LayoutDashboard size={14} /> Dashboard</Link>
            <Link to="/jobs" className="btn btn-ghost btn-sm"><Briefcase size={14} /> Schedule / Jobs</Link>
            <Link to="/clients" className="btn btn-ghost btn-sm"><Users size={14} /> Client Workspace</Link>
            <Link to="/quotes" className="btn btn-ghost btn-sm"><FileText size={14} /> Quotes</Link>
            <Link to="/jobs" className="btn btn-ghost btn-sm"><Wrench size={14} /> Job Workspace</Link>
          </div>
        </section>

        <section className="card" data-testid="help-section-common-tasks">
          <div className="card-header"><h3 style={{ fontWeight: 600 }}>Common tasks</h3></div>
          <div className="card-body" style={{ display: 'grid', gap: 8 }}>
            <div>• Create a client: <Link to="/clients">Clients</Link> → Create Client</div>
            <div>• Create a quote: open Client Workspace or go to <Link to="/quotes/new">Create Quote</Link></div>
            <div>• Convert quote to job: open accepted quote → Convert to Job</div>
            <div>• Assign crew: open job → Crew section → Add</div>
            <div>• Mark progress: use Schedule quick actions or update status in Job Detail</div>
          </div>
        </section>
      </div>
    </div>
  )
}
